import { useAppTheme } from "../../../hooks/useAppTheme";
import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import {
  StyleSheet,
  ScrollView,
  Text,
  TouchableOpacity,
  Modal as RNModal,
  View as RNView,
  Pressable,
  Platform,
} from "react-native";
import { DataTable } from "react-native-paper";
import { View } from "../../../components/shared/Themed";
import { LabelBannerWithSearchBar } from "../../../components/custom/Banners/LabelBannerWithSearchBar";
import { DataTableWithPagination } from "../../../components/custom/DataTable/DataTableWithPagination";
import { default as Modal } from "../../../components/custom/Modal/index";
import Spinner from "../../../components/shared/Spinner";
import { getCustomerStatus } from "../../../services/customerStatusService";
import { validSignedURL } from "../../../utils/validateSignedUrl";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import {
  headersCustomerStatus,
  mdHeadersCustomerStatus,
  smHeadersCustomerStatus,
} from "../utils/customerStatusHeaders";
import { customerStatusModel } from "../../../models/reportsModel";
import { handleTableLoader } from "../../../utils/common";
import { useSelector } from "react-redux";
import { userClaimInformation } from "../../../models/usersModel";
import { filterBasedOnAnyKey } from "../../../utils/searchInArrays";
import { sortColumns } from "../../../utils/sortColumns";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {
  translateHeaders,
  useTranslation,
} from "../../../utils/useTranslation";
import { customerStatusTranslationMap } from "../../../utils/translations";
// @ts-ignore
import { Feather, Ionicons } from "@expo/vector-icons";

export default function CustomerStatusReportScreen({ route, navigation }: any) {
  const { colors, isDark } = useAppTheme();
  const { isLargeDevice, isMediumDevice, isSmallDevice, isMobileDevice } = useContext(
    DeviceOrientationContext,
  );
  const styles = React.useMemo(() => createStyles(colors, isDark), [colors, isDark]);
  const { t } = useTranslation();

  const [mobilePage, setMobilePage] = useState<number>(0);
  const itemsPerPage = 20;

  const [contentOffSet, setContentOffSet] = useState<number>(0);
  const [isAtBottom, setIsAtBottom] = useState<boolean>(false);
  
  const cardStyles = React.useMemo(() => createCardStyles(colors, isDark), [colors, isDark]);

  const MobileCustomerStatusCard = ({ cs }: { cs: customerStatusModel }) => {
    return (
      <View
        style={cardStyles.card}
      >
        <RNView style={cardStyles.cardHeader}>
          <RNView style={cardStyles.cardHeaderLeft}>
            <RNView style={cardStyles.containerIconWrap}>
              <Ionicons name="briefcase-outline" size={18} color={isDark ? colors.primary : "#3B82F6"} />
            </RNView>
            <RNView style={{ flex: 1, backgroundColor: "transparent" }}>
              <Text style={cardStyles.containerNumber}>{cs.CardName || "Unknown"}</Text>
            </RNView>
          </RNView>
        </RNView>

        <View style={cardStyles.divider} />

        <View style={cardStyles.dateRow}>
          <View style={cardStyles.dateBlock}>
            <Text style={cardStyles.dateLabel}>{t("creditLimit" as any) ? (t("creditLimit" as any) as string).toUpperCase() : "CREDIT LIMIT"}</Text>
            <Text style={cardStyles.dateValue}>{cs.CreditLine ? Number(cs.CreditLine).toLocaleString("en-US") : "0"}</Text>
          </View>
          <View style={{ width: 1, height: 24, backgroundColor: isDark ? colors.border : "#E2E8F0" }} />
          <View style={cardStyles.dateBlock}>
            <Text style={cardStyles.dateLabel}>{t("balance" as any) ? (t("balance" as any) as string).toUpperCase() : "BALANCE"}</Text>
            <Text style={cardStyles.dateValue}>{cs.Balance ? Number(cs.Balance).toLocaleString("en-US") : "0"}</Text>
          </View>
          <View style={{ width: 1, height: 24, backgroundColor: isDark ? colors.border : "#E2E8F0" }} />
          <View style={cardStyles.dateBlock}>
            <Text style={cardStyles.dateLabel}>{t("available" as any) ? (t("available" as any) as string).toUpperCase() : "AVAILABLE"}</Text>
            <Text style={cardStyles.dateValue}>{cs.CreditLimitAvailable ? Number(cs.CreditLimitAvailable).toLocaleString("en-US") : "0"}</Text>
          </View>
        </View>

        <View style={cardStyles.divider} />

        <View style={cardStyles.cardFooter}>
          <View style={cardStyles.metaChip}>
            <Ionicons name="pricetag-outline" size={12} color={isDark ? colors.textSecondary : "#64748B"} />
            <Text style={cardStyles.metaChipText}>{cs.CardCode || "-"}</Text>
          </View>
          <View style={cardStyles.metaChip}>
            <Ionicons name="person-outline" size={12} color={isDark ? colors.textSecondary : "#64748B"} />
            <Text style={cardStyles.metaChipText}>{cs.SlpName || "-"}</Text>
          </View>
          {cs.AccountStatus && (
            <View style={cardStyles.metaChip}>
              <Ionicons name="ellipse" size={8} color={cs.AccountStatus.toLowerCase() === 'active' ? colors.success : colors.warning} />
              <Text style={cardStyles.metaChipText}>{cs.AccountStatus}</Text>
            </View>
          )}
          {cs.PymntGroup && (
            <View style={cardStyles.metaChip}>
              <Ionicons name="card-outline" size={12} color={isDark ? colors.textSecondary : "#64748B"} />
              <Text style={cardStyles.metaChipText}>{cs.PymntGroup}</Text>
            </View>
          )}
        </View>
      </View>
    );
  };

  const { customerStatusReport, isCustomerStatusReportListLoaded } =
    useSelector((state: any) => state.reports);
  const { userInfo, language } = useSelector(
    (state: any) => state.configurations,
  );

  const [selected, setSelected] = useState<customerStatusModel>(
    {} as unknown as customerStatusModel,
  );

  const [customerStatusPageLevelList, setCustomerStatusPageLevelList] =
    useState<Array<customerStatusModel>>([]);
  const [isSearched, setIsSearched] = useState<boolean>(false);

  const [tableHeaders, setTableHeaders] = useState<
    Record<string, Record<string, string | number | boolean>>
  >(headersCustomerStatus);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [isRefresh, setRefresh] = useState<boolean>(false);
  const [isImageLoading, setImageLoading] = useState<boolean>(true);

  // Column visibility settings
  const [columnSettingsOpen, setColumnSettingsOpen] = useState<boolean>(false);
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [columnOrder, setColumnOrder] = useState<string[]>([]);
  const [settingsBtnPos, setSettingsBtnPos] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const settingsBtnRef = useRef<any>(null);
  const listRef = useRef<ScrollView>(null);

  useEffect(() => {
    setMobilePage(0);
  }, [customerStatusPageLevelList]);

  // Load saved hidden columns from storage on mount
  useEffect(() => {
    AsyncStorage.getItem("customer_status_report_hidden_columns").then(
      (stored) => {
        if (stored) {
          try {
            setHiddenColumns(JSON.parse(stored));
          } catch { }
        }
      },
    );
  }, []);

  useEffect(() => {
    navigation.setOptions({ title: t("customerStatus") });
  }, [navigation, language, t]);

  // All available headers based on device size
  const getAllHeaders = () => {
    const base = isLargeDevice
      ? headersCustomerStatus
      : isMediumDevice
        ? mdHeadersCustomerStatus
        : smHeadersCustomerStatus;
    return translateHeaders(base, t, customerStatusTranslationMap);
  };

  const getOrderedKeys = (
    baseHeaders: Record<string, Record<string, string | number | boolean>>,
  ) => {
    const allKeys = Object.keys(baseHeaders);
    if (columnOrder.length === 0) return allKeys;
    const ordered: string[] = [];
    columnOrder.forEach((k) => {
      if (allKeys.includes(k)) ordered.push(k);
    });
    allKeys.forEach((k) => {
      if (!ordered.includes(k)) ordered.push(k);
    });
    return ordered;
  };

  const getFilteredHeaders = (
    baseHeaders: Record<string, Record<string, string | number | boolean>>,
  ) => {
    const orderedKeys = getOrderedKeys(baseHeaders);
    const visibleEntries = orderedKeys
      .filter((key) => !hiddenColumns.includes(key))
      .map(
        (key) =>
          [key, baseHeaders[key]] as [
            string,
            Record<string, string | number | boolean>,
          ],
      );
    const totalOriginalFlex = Object.values(baseHeaders).reduce(
      (sum, h) => sum + (Number(h.width) || 0),
      0,
    );
    const totalVisibleFlex = visibleEntries.reduce(
      (sum, [, h]) => sum + (Number(h.width) || 0),
      0,
    );
    const scale =
      totalVisibleFlex > 0 ? totalOriginalFlex / totalVisibleFlex : 1;

    const result: Record<
      string,
      Record<string, string | number | boolean>
    > = {};
    visibleEntries.forEach(([key, value]) => {
      result[key] = { ...value, width: Number(value.width) * scale };
    });
    return result;
  };

  // Update table headers when hidden columns change or device size changes
  useEffect(() => {
    const allHeaders = getAllHeaders();
    setTableHeaders(getFilteredHeaders(allHeaders));
  }, [hiddenColumns, columnOrder, isLargeDevice, isMediumDevice, language]);

  const toggleColumn = (columnKey: string) => {
    setHiddenColumns((prev) => {
      const updated = prev.includes(columnKey)
        ? prev.filter((k) => k !== columnKey)
        : [...prev, columnKey];
      AsyncStorage.setItem(
        "customer_status_report_hidden_columns",
        JSON.stringify(updated),
      );
      return updated;
    });
  };

  const moveColumn = useCallback(
    (fromKey: string, toKey: string) => {
      const allHeaders = getAllHeaders();
      const currentKeys = getOrderedKeys(allHeaders).filter((k) => k !== "");
      const fromIdx = currentKeys.indexOf(fromKey);
      const toIdx = currentKeys.indexOf(toKey);
      if (fromIdx < 0 || toIdx < 0 || fromIdx === toIdx) return;
      const newKeys = [...currentKeys];
      newKeys.splice(fromIdx, 1);
      newKeys.splice(toIdx, 0, fromKey);
      newKeys.push("");
      setColumnOrder(newKeys);
      AsyncStorage.setItem(
        "customer_status_column_order",
        JSON.stringify(newKeys),
      );
    },
    [columnOrder],
  );

  const resetColumnOrder = () => {
    setColumnOrder([]);
    AsyncStorage.removeItem("customer_status_column_order");
  };

  // Drag-and-drop reordering via window mouse events
  const [dragActiveKey, setDragActiveKey] = useState<string | null>(null);
  const [dragOverKey, setDragOverKey] = useState<string | null>(null);
  const dragRef = useRef<{ activeKey: string | null; overKey: string | null }>({
    activeKey: null,
    overKey: null,
  });

  const startColumnDrag = useCallback(
    (key: string) => {
      if (Platform.OS !== "web" || typeof window === "undefined") return;
      dragRef.current.activeKey = key;
      setDragActiveKey(key);

      const onMouseMove = (e: MouseEvent) => {
        const el = document.elementFromPoint(e.clientX, e.clientY);
        const row =
          el && (el as HTMLElement).closest
            ? (el as HTMLElement).closest("[data-columnkey]")
            : null;
        const overKey = row ? row.getAttribute("data-columnkey") : null;
        if (overKey !== dragRef.current.overKey) {
          dragRef.current.overKey = overKey;
          setDragOverKey(
            overKey && overKey !== dragRef.current.activeKey ? overKey : null,
          );
        }
      };

      const onMouseUp = () => {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
        document.body.style.cursor = "";
        (document.body.style as any).userSelect = "";
        const from = dragRef.current.activeKey;
        const to = dragRef.current.overKey;
        if (from && to && from !== to) {
          moveColumn(from, to);
        }
        dragRef.current = { activeKey: null, overKey: null };
        setDragActiveKey(null);
        setDragOverKey(null);
      };

      document.body.style.cursor = "grabbing";
      (document.body.style as any).userSelect = "none";
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    },
    [moveColumn],
  );

  const displayTableLoader = () => {
    handleTableLoader(true, false, setIsSearched);
  };

  const convertCustomerStatusData = (
    _customerStatusReport: Array<customerStatusModel>,
  ) => {
    return _customerStatusReport.map((cs: customerStatusModel) => {
      return {
        ...cs,
        AccountStatus:
          cs.AccountStatus === null ? "Contact Office" : cs.AccountStatus,
      };
    });
  };

  const fadeTableLoader = () => {
    handleTableLoader(false, true, setIsSearched);
  };

  const handleSearch = (searchText: string) => {
    displayTableLoader();

    if (searchText.trim() !== "") {
      const searchedList: Array<customerStatusModel> = filterBasedOnAnyKey(
        customerStatusReport,
        searchText,
      );
      setCustomerStatusPageLevelList(convertCustomerStatusData(searchedList));
    }

    setTimeout(() => {
      fadeTableLoader();
    }, 1000);
  };

  const onHandleSortColumn = (columnKey: string) => {
    const _sortedCustomerStatusList: Array<customerStatusModel> = sortColumns(
      customerStatusPageLevelList,
      columnKey,
      tableHeaders,
      setTableHeaders,
    );

    setCustomerStatusPageLevelList(_sortedCustomerStatusList);
  };

  useEffect(() => {
    let isMounted: boolean = true;
    const _userInfo = userInfo as userClaimInformation;

    // Avoid keep refreshing table when item is selected
    if (isMounted) {
      if (customerStatusPageLevelList.length === 0 || isRefresh) {
        displayTableLoader();
        getCustomerStatus(
          "",
          _userInfo.team,
          `${_userInfo.first_name} ${_userInfo.last_name}`,
          tableHeaders,
        );
      }
    }

    if (Object.keys(selected).length !== 0) {
      validSignedURL(
        selected.CardCode,
        "avatar",
        setImageLoading,
        setSelectedImage,
      );
    }

    const allHeaders = getAllHeaders();
    setTableHeaders(getFilteredHeaders(allHeaders));

    setRefresh(false);

    return () => {
      isMounted = false;
    };
  }, [selected, isRefresh]);

  useEffect(() => {
    setCustomerStatusPageLevelList(
      convertCustomerStatusData(customerStatusReport),
    );

    setTimeout(() => {
      fadeTableLoader();
    }, 2000);
  }, [customerStatusReport]);

  const ModalContent = (props: any) => {
    const _excludedKeys = [""];

    const _orderedKeys = [
      "AccountStatus",
      "CardCode",
      "CardName",
      "PymntGroup",
      "CreditLine",
      "CreditLimitAvailable",
      "Variance",
      "Balance",
      "OpenDeliveries",
      "CommittedOrders",
      "SlpName",
    ];

    return (
      <Modal.ModalContent {...props}
        title={selected.CardCode || ""}
        icon="folder"
        loading={isImageLoading}
        childern={
          <Modal.ModalBody
            listData={selected}
            excludedKeys={_excludedKeys}
            renameList={headersCustomerStatus}
            orderedKeys={_orderedKeys}
          />
        }
      />
    );
  };

  const handleScroll = (event: any) => {
    const { contentOffset, layoutMeasurement, contentSize } = event.nativeEvent;
    setContentOffSet(contentOffset.y);

    if (layoutMeasurement.height + contentOffset.y >= contentSize.height - 100) {
      setIsAtBottom(true);
    } else {
      setIsAtBottom(false);
    }
  };

  const navigateToOrder = (details: any, action: string) => {
    if (action === "details") {
      navigation.navigate("CustomerStatusDetailReportScreen", { order: details });
    }
  };

  return (
    <View style={{ flex: 1, backgroundColor: isDark ? colors.background : "#eef2f6" }}>
      <ScrollView style={{ flex: 1, backgroundColor: isDark ? colors.background : "#eef2f6" }} contentContainerStyle={{ flexGrow: 1, backgroundColor: isDark ? colors.background : "#eef2f6" }} onScroll={handleScroll} scrollEventThrottle={16} ref={listRef}>
        <View
          style={[
            styles.pageWrapper,
            { backgroundColor: columnSettingsOpen ? colors.primaryBg : (isDark ? colors.background : "#eef2f6") }
          ]}
        >
            {isCustomerStatusReportListLoaded ? (
              <>
              <View style={[styles.tableCard, !(isSmallDevice || isMobileDevice) && { marginTop: 12 }, (isSmallDevice || isMobileDevice) && { marginBottom: 8 }]}>
                <LabelBannerWithSearchBar
                  titleName={`${t("totalItems")}: ${customerStatusPageLevelList.length}`}
                  handleSearch={handleSearch}
                  setRefresh={setRefresh}
                  dataToExport={customerStatusPageLevelList.map((cs) => {
                    const formatNumber = (val: any) => {
                      if (val === null || val === undefined || val === "")
                        return val;
                      const num = Number(val);
                      return isNaN(num) ? val : num.toLocaleString("en-US");
                    };
                    return {
                      "Account Status": cs.AccountStatus,
                      "Customer Code": cs.CardCode,
                      "Customer Name": cs.CardName,
                      "Payment Group": cs.PymntGroup,
                      "Credit Line": formatNumber(cs.CreditLine),
                      "Credit Limit Available": formatNumber(
                        cs.CreditLimitAvailable,
                      ),
                      Variance: formatNumber(cs.Variance),
                      Balance: formatNumber(cs.Balance),
                      "Open Deliveries": formatNumber(cs.OpenDeliveries),
                      "Committed Orders": formatNumber(cs.CommittedOrders),
                      Sales: cs.SlpName,
                    };
                  })}
                  fileName="customerStatusReport"
                  sheetName="Customer Status Report"
                  preSearchControls={
                    !(isSmallDevice || isMobileDevice) ? (
                    <RNView>
                      <TouchableOpacity
                        ref={settingsBtnRef}
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 10,
                          backgroundColor: colors.surfaceSubtle,
                          justifyContent: "center",
                          alignItems: "center",
                          borderWidth: 1,
                          borderColor: columnSettingsOpen ? colors.primary : colors.border,
                        }}
                        onPress={() => {
                          if (settingsBtnRef.current) {
                            settingsBtnRef.current.measureInWindow(
                              (
                                x: number,
                                y: number,
                                width: number,
                                height: number,
                              ) => {
                                setSettingsBtnPos({
                                  x: x || 0,
                                  y: y || 0,
                                  width: width || 0,
                                  height: height || 0,
                                });
                                setColumnSettingsOpen(!columnSettingsOpen);
                              },
                            );
                          } else {
                            setColumnSettingsOpen(!columnSettingsOpen);
                          }
                        }}
                      >
                        <Feather
                          name="settings"
                          size={15}
                          color={columnSettingsOpen ? colors.primary : colors.textSecondary}
                        />
                      </TouchableOpacity>
                      {columnSettingsOpen && (
                        <RNModal
                          transparent={true}
                          visible={columnSettingsOpen}
                          animationType="fade"
                          onRequestClose={() => setColumnSettingsOpen(false)}
                        >
                          <Pressable
                            style={{
                              flex: 1,
                              backgroundColor: "rgba(0,0,0,0.15)",
                            }}
                            onPress={() => setColumnSettingsOpen(false)}
                          >
                            <Pressable
                              style={{
                                position: "absolute",
                                top: settingsBtnPos.y + settingsBtnPos.height + 6,
                                left: settingsBtnPos.x - 180 + 40,
                                backgroundColor: colors.surface,
                                borderRadius: 12,
                                borderWidth: 1,
                                borderColor: colors.border,
                                paddingVertical: 10,
                                minWidth: 220,
                                shadowColor: "#000",
                                shadowOffset: { width: 0, height: 8 },
                                shadowOpacity: 0.15,
                                shadowRadius: 20,
                                elevation: 10,
                              }}
                              onPress={(e) => e.stopPropagation()}
                            >
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontWeight: "700",
                                  color: colors.textSecondary,
                                  paddingHorizontal: 16,
                                  paddingBottom: 8,
                                  textTransform: "uppercase",
                                  letterSpacing: 0.5,
                                }}
                              >
                                {t("showHideColumns")}
                              </Text>
                              <View
                                style={{
                                  height: 1,
                                  backgroundColor: colors.borderSubtle,
                                  marginBottom: 4,
                                }}
                              />
                              {/* Select All */}
                              <TouchableOpacity
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  paddingVertical: 8,
                                  paddingHorizontal: 16,
                                }}
                                onPress={() => {
                                  const allKeys = Object.keys(getAllHeaders()).filter(
                                    (k) => k !== "",
                                  );
                                  if (hiddenColumns.length === 0) {
                                    const updated = [...allKeys];
                                    setHiddenColumns(updated);
                                    AsyncStorage.setItem(
                                      "customer_status_report_hidden_columns",
                                      JSON.stringify(updated),
                                    );
                                  } else {
                                    setHiddenColumns([]);
                                    AsyncStorage.setItem(
                                      "customer_status_report_hidden_columns",
                                      JSON.stringify([]),
                                    );
                                  }
                                }}
                              >
                                <View
                                  style={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: 4,
                                    borderWidth: 1.5,
                                    borderColor:
                                      hiddenColumns.length === 0
                                        ? colors.primary
                                        : colors.textMuted,
                                    backgroundColor:
                                      hiddenColumns.length === 0 ? colors.primary : colors.surface,
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginRight: 10,
                                  }}
                                >
                                  {hiddenColumns.length === 0 && (
                                    <Feather name="check" size={13} color="#fff" />
                                  )}
                                </View>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    color: colors.text,
                                    fontWeight: "700",
                                  }}
                                >
                                  {t("selectAll")}
                                </Text>
                              </TouchableOpacity>
                              <View
                                style={{
                                  height: 1,
                                  backgroundColor: colors.borderSubtle,
                                  marginBottom: 2,
                                }}
                              />
                              <ScrollView
                                style={{ maxHeight: 300 }}
                                showsVerticalScrollIndicator={true}
                              >
                                {getOrderedKeys(getAllHeaders()).map((key) => {
                                  if (key === "") return null;
                                  const value = getAllHeaders()[key];
                                  if (!value) return null;
                                  const isVisible = !hiddenColumns.includes(key);
                                  const isDragging = dragActiveKey === key;
                                  const isDragOver = dragOverKey === key;
                                  return (
                                    <View
                                      key={key}
                                      {...({ dataSet: { columnkey: key } } as any)}
                                      style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        paddingVertical: 8,
                                        paddingHorizontal: 16,
                                        opacity: isDragging ? 0.35 : 1,
                                        backgroundColor: isDragOver
                                          ? colors.primaryBg
                                          : "transparent",
                                        borderTopWidth: isDragOver ? 2 : 0,
                                        borderTopColor: colors.primary,
                                      }}
                                    >
                                      <Pressable
                                        onPressIn={() => startColumnDrag(key)}
                                        style={
                                          {
                                            padding: 4,
                                            marginRight: 6,
                                            cursor: "grab",
                                          } as any
                                        }
                                      >
                                        <Feather
                                          name="menu"
                                          size={14}
                                          color={colors.textMuted}
                                        />
                                      </Pressable>
                                      <TouchableOpacity
                                        style={{
                                          flexDirection: "row",
                                          alignItems: "center",
                                          flex: 1,
                                        }}
                                        onPress={() => toggleColumn(key)}
                                      >
                                        <View
                                          style={{
                                            width: 20,
                                            height: 20,
                                            borderRadius: 4,
                                            borderWidth: 1.5,
                                            borderColor: isVisible
                                              ? colors.primary
                                              : colors.textMuted,
                                            backgroundColor: isVisible
                                              ? colors.primary : colors.surface,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginRight: 10,
                                          }}
                                        >
                                          {isVisible && (
                                            <Feather
                                              name="check"
                                              size={13}
                                              color="#fff"
                                            />
                                          )}
                                        </View>
                                        <Text
                                          style={{
                                            fontSize: 14,
                                            color: isVisible ? colors.text : colors.textMuted,
                                            fontWeight: isVisible ? "600" : "400",
                                          }}
                                        >
                                          {(value as any).name}
                                        </Text>
                                      </TouchableOpacity>
                                    </View>
                                  );
                                })}
                              </ScrollView>
                            {columnOrder.length > 0 && (
                              <>
                                <View
                                  style={{
                                    height: 1,
                                    backgroundColor: colors.borderSubtle,
                                    marginTop: 4,
                                  }}
                                />
                                <TouchableOpacity
                                  style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    paddingVertical: 10,
                                    paddingHorizontal: 16,
                                  }}
                                  onPress={resetColumnOrder}
                                >
                                  <Feather
                                    name="rotate-ccw"
                                    size={13}
                                    color={colors.textSecondary}
                                  />
                                  <Text
                                    style={{
                                      fontSize: 13,
                                      color: colors.textSecondary,
                                      fontWeight: "600",
                                      marginLeft: 6,
                                    }}
                                  >
                                    {t("resetOrder")}
                                  </Text>
                                </TouchableOpacity>
                              </>
                            )}
                          </Pressable>
                        </Pressable>
                    </RNModal>
                  )}
              </RNView>
                    ) : undefined
                }
              />
            {!isSmallDevice && (
              <DataTableWithPagination
                headers={tableHeaders}
                rows={customerStatusPageLevelList}
                itemsPerPage={100}
                useModal={false}
                isDataLoading={isSearched}
                isRowsExpandable={false}
                setModalVisible={setModalVisible}
                setSelected={setSelected}
                isDetail={true}
                selectable={true}
                handleRowClick={() => { }}
                handleDeleteRow={() => { }}
                handleSortColumn={onHandleSortColumn}
                operationActions={navigateToOrder}
              />
            )}
          </View>

          {isSmallDevice && (
            <View style={cardStyles.cardList}>
              {customerStatusPageLevelList.length === 0 ? (
                <View style={cardStyles.emptyState}>
                  <Ionicons name="briefcase-outline" size={48} color="#CBD5E1" />
                  <Text style={cardStyles.emptyStateText}>{(t("noDataAvailable" as any) as string) || "No Data Available"}</Text>
                </View>
              ) : (
                <>
                  {customerStatusPageLevelList
                    .slice(mobilePage * itemsPerPage, (mobilePage + 1) * itemsPerPage)
                    .map((cs, index) => (
                      <MobileCustomerStatusCard key={cs.CardCode || index} cs={cs} />
                    ))}
                  <DataTable.Pagination
                    page={mobilePage}
                    numberOfPages={Math.ceil(customerStatusPageLevelList.length / itemsPerPage)}
                    onPageChange={(page) => setMobilePage(page)}
                    label={`${mobilePage * itemsPerPage + 1}-${Math.min(
                      (mobilePage + 1) * itemsPerPage,
                      customerStatusPageLevelList.length
                    )} of ${customerStatusPageLevelList.length}`}
                    showFastPaginationControls
                  />
                </>
              )}
            </View>
          )}
          </>
          ) : (
        <View>
          <Spinner
            size="small"
            color="#74BBFF"
            styles={{ flexDirection: "row", margin: "20%" }}
          />
        </View>
          )}
        </View>
      {isSmallDevice && contentOffSet > 200 && (
        <TouchableOpacity
          style={{
            position: "absolute",
            right: 16,
            bottom: isAtBottom ? 110 : 16,
            backgroundColor: isDark ? colors.primary : "#2F95DC",
            width: 48,
            height: 48,
            borderRadius: 24,
            justifyContent: "center",
            alignItems: "center",
            opacity: 0.85,
            elevation: 4,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.25,
            shadowRadius: 3.84,
          }}
          onPress={() => {
            listRef.current?.scrollTo({ y: 0, animated: true });
          }}
        >
          <Ionicons name="arrow-up" size={24} color="white" />
        </TouchableOpacity>
      )}
      </ScrollView >
    </View >
  );
}

const createStyles = (colors: any, isDark: boolean) => StyleSheet.create({
  tableCard: {
    marginHorizontal: 16,
    marginBottom: 24,
    marginTop: 12,
    backgroundColor: isDark ? colors.surface : "#FFFFFF",
    borderRadius: 16,
    borderWidth: 1,
    borderColor: isDark ? colors.border : "#E2E8F0",
    overflow: "hidden" as any,
    shadowColor: isDark ? colors.text : "#0F172A",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.07,
    shadowRadius: 12,
    elevation: 4,
  },
  pageWrapper: {
    flex: 1,
    minHeight: "100%" as any,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
});

function createCardStyles(colors: any, isDark: boolean) {
  return StyleSheet.create({
    cardList: {
      paddingHorizontal: 16,
      paddingBottom: 24,
      paddingTop: 8,
      gap: 12,
      backgroundColor: "transparent",
    },
    tableCard: {
      marginHorizontal: 16,
      marginBottom: 24,
      marginTop: 12,
      backgroundColor: isDark ? colors.surface : "#FFFFFF",
      borderRadius: 16,
      borderWidth: 1,
      borderColor: isDark ? colors.border : "#E2E8F0",
      overflow: "hidden" as any,
      shadowColor: isDark ? colors.text : "#0F172A",
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.07,
      shadowRadius: 12,
      elevation: 4,
    },
    card: {
      backgroundColor: isDark ? colors.surface : "#FFFFFF",
      borderRadius: 16,
      borderWidth: 1,
      borderColor: isDark ? colors.border : "#E8EDF5",
      shadowColor: isDark ? colors.text : "#1E293B",
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.07,
      shadowRadius: 10,
      elevation: 3,
      overflow: "hidden" as any,
      marginBottom: 4,
    },
    cardHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingHorizontal: 16,
      paddingVertical: 14,
      backgroundColor: isDark ? colors.surfaceSubtle : "#FAFBFF",
    },
    cardHeaderLeft: {
      flexDirection: "row",
      alignItems: "center",
      gap: 10,
      backgroundColor: "transparent",
      flex: 1,
      paddingRight: 10,
    },
    containerIconWrap: {
      width: 34,
      height: 34,
      borderRadius: 10,
      backgroundColor: isDark ? colors.primary + "33" : "#E1F0FA",
      alignItems: "center",
      justifyContent: "center",
    },
    containerNumber: {
      fontSize: 14,
      fontWeight: "700" as const,
      color: isDark ? colors.text : "#0F172A",
      letterSpacing: 0.2,
      flexWrap: "wrap",
      backgroundColor: "transparent",
    },
    divider: {
      height: 1,
      backgroundColor: isDark ? colors.background : "#eef2f6",
      marginHorizontal: 16,
    },
    dateRow: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingHorizontal: 16,
      paddingVertical: 14,
      gap: 4,
    },
    dateBlock: {
      flex: 1,
      alignItems: "center",
      gap: 3,
    },
    dateLabel: {
      fontSize: 10,
      color: isDark ? colors.textSecondary : "#94A3B8",
      fontWeight: "600" as const,
      textTransform: "uppercase" as any,
      letterSpacing: 0.5,
    },
    dateValue: {
      fontSize: 13,
      color: isDark ? colors.text : "#1E293B",
      fontWeight: "700" as const,
    },
    cardFooter: {
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "wrap" as any,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderTopWidth: 1,
      borderTopColor: isDark ? colors.background : "#eef2f6",
      backgroundColor: isDark ? colors.surfaceSubtle : "#FAFBFF",
      gap: 8,
    },
    metaChip: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: isDark ? colors.surface : "#FFFFFF",
      borderRadius: 6,
      paddingVertical: 4,
      paddingHorizontal: 8,
      gap: 4,
      borderWidth: 1,
      borderColor: isDark ? colors.border : "#E2E8F0",
      flexShrink: 1,
      maxWidth: "100%",
    },
    metaChipText: {
      fontSize: 11,
      color: isDark ? colors.textSecondary : "#6B7280",
      fontWeight: "500" as const,
      flexShrink: 1,
    },
    emptyState: {
      alignItems: "center",
      paddingVertical: 60,
      gap: 12,
    },
    emptyStateText: {
      fontSize: 15,
      color: "#CBD5E1",
      fontWeight: "500" as const,
    },
  });
}
